module.exports = __webpack_public_path__ + "static/1-2ca5ae50d3ee6392f4644b449077f7c7.gif";